import { Gender, type SubmitBuyerPassenger } from '@store/form';
import {
    type CaptchaInput,
    ReservesApiApiRegisterInfoPost,
} from '@clients/TrainApi';
import BillHandler from '@itinerary/BillHandler';
import type TripPackage from '@itinerary/trip/TripPackage';
import type TrainPriceClass from '@itinerary/trip/train/TrainPriceClass';
import { ReserveType } from '@utils/itinerary';
import { PaxType } from '@utils/types';
import { RegisterPaxError } from '@itinerary/Exceptions';

export default class TrainBillHandler extends BillHandler {
    override async registerPaxInfo(params: {
        pax: SubmitBuyerPassenger[];
        email: string;
        mobile: string;
        destinationMobile: string;
        billId: number;
        customData: { captcha: CaptchaInput };
    }): Promise<{
        result: boolean;
        departureTime: Date | null;
        data?: any;
    }> {
        const { data } = await ReservesApiApiRegisterInfoPost({
            registerInfoRequest: {
                billID: params.billId,
                email: params.email,
                mobile: params.mobile,
                people: params.pax.map(p => ({
                    paxType:
                        p.type === PaxType.Adult
                            ? 'ADL'
                            : p.type === PaxType.Child
                              ? 'CHD'
                              : 'INF',
                    persianFirstName: p.persianFirstName,
                    persianLastName: p.persianLastName,
                    firstName: p.firstName,
                    infantWithSeat: p.infantSeat,
                    lastName: p.lastName,
                    male: p.gender === Gender.Male,
                    birthDay: p.birthDate,
                    nationalCode: p.nationalCode,
                    nationality: p.nationalityCode,
                    passportExpiration: p.passportExpiry,
                    passportNumber: p.passportNumber,
                    trainCars: p.carModel
                        ? [
                              {
                                  Type: p.carModel,
                                  platePart1: parseInt(p.carPlate[0]),
                                  platePart2: p.carPlate[1],
                                  platePart3: parseInt(p.carPlate[2]),
                                  platePart4: p.carPlate[3],
                                  platePart5: parseInt(p.carPlate[4]),
                              },
                          ]
                        : [],
                    trainCapacityOptionalService: p.packageOptionalService
                        ? Object.fromEntries(
                              p.packageOptionalService
                                  .filter(item => item?.service)
                                  .map(item => [
                                      (
                                          (
                                              item?.itineraryPackage as
                                                  | TripPackage
                                                  | undefined
                                          )?.selectedPrice as
                                              | TrainPriceClass
                                              | undefined
                                      )?.id,
                                      item?.service?.id,
                                  ])
                          )
                        : null,
                    trainFreeServiceCodes: p.packageFreeService.flatMap(
                        s =>
                            s.services?.map(
                                selectedService => selectedService.id
                            ) || []
                    ),
                })),
                phone: '',
                captchaInput: params.customData.captcha ?? null,
            },
        });

        if (
            data.trainTripInfos?.some(
                info =>
                    (info.compartmentNumbers?.length ?? 0) > 1 ||
                    (info.wagonNumbers?.length ?? 0) > 1
            )
        ) {
            throw new RegisterPaxError(
                'احتمال پراکندگی صندلی‌ها وجود دارد. در صورت موافقت خرید خود را انجام دهید.',
                true,
                null,
                data.trainTripInfos
            );
        }

        return {
            result: !!data.result,
            departureTime: null,
            data: data.trainTripInfos,
        };
    }

    override async prepayReservation(_billCode: string) {
        await Promise.resolve();
    }

    override get isSingleForRoundTrip(): boolean {
        return true;
    }

    override concreteType? = ReserveType.Train;
}
